import AVdxbSelectField from './index.vue';

AVdxbSelectField.install = app => {
  app.component(AVdxbSelectField.name, AVdxbSelectField);
};

export default AVdxbSelectField;
